import React  from 'react';
import Flatpickr from 'react-flatpickr'
var ReactSuperSelect = require('react-super-select')

class SpecialMessages extends React.PureComponent  {
	constructor(props) {
		super(props);
		this.state = {
			editingMessage: false,
			loading: false,
		};
	}

	editMessage = (message) => e => {
		this.setState({editingMessage: true, loading: false, editPrompt: message.Prompt, ActionAfterPlaying: message.ActionAfterPlaying, description: message.Description, error: '', start: message.Active_StartDateTime, end: message.Active_EndDateTime, active: message.is_active})
	}
    editAction = (option) =>  {
		this.setState({ActionAfterPlaying: option.name, error: ''});
	}
	editDescription = (e) =>  {
		if (e.target.value.length < 1){
			this.setState({description: '', error: 'Please enter a description for this prompt.'});
		} else {
			this.setState({description: e.target.value, error: ''});
		}
	}
	cancelEditMessage = () => {
		this.setState({editingMessage: false, loading: false, editPrompt: false, start:false, end: false,active: null})
	}
	confirmEditMessage = () => {
		if (this.state.description.length < 1){
			this.setState({error: 'Please enter a description for this prompt.'});
		} else if (new Date(this.state.start) > new Date( this.state.end)) {
			this.setState({error: 'End date must not be before start date.'});
		}else {
			this.setState({ loading: true });
			this.props.ws.send(JSON.stringify({route: 'editSpecialMessage', editPrompt: this.state.editPrompt,  description: this.state.description, start: this.state.start, end: this.state.end, ActionAfterPlaying: this.state.ActionAfterPlaying, active:this.state.active  }))
		}
	}

	checkEnter = (e) => {
		if(e.keyCode === 13){
			this.confirmEditMessage();
		}
	}

	toggle = (param) => (e) => {
		var newState = Object.assign({}, this.state)
		newState[param] = this.state[param] ? false : true
		this.setState(newState)
	}

	componentWillReceiveProps(nextProps) {
		if(this.state.loading) {
			this.setState({ editingMessage: false, loading: false });
		}
	}
	render() {
		if (this.props.active) {
			var smList = []
			for (var message of this.props.data.SpecialMessages) {
				smList.push(
					<div className="dataRow" key={message.Id} onClick={this.editMessage(message)}>
						<div className="activeBox">
							<div className={message.is_active ? "enabled" : "disabled"}></div>
						</div>
						<span style={{flex: '1 0 20%'}}>{message.Description}</span>
                        <span style={{flex: '0 0 200px', textAlign: 'center'}}>{message.ActionAfterPlaying}</span>
						<span style={{flex: '1 0 30%'}}>{new Date(message.Active_StartDateTime).toLocaleString() +' - '+ new Date(message.Active_EndDateTime).toLocaleString()}</span>
					</div>
				)
			}

			var editMessage = ""
            var actions = [{id:'Continue', name:'Continue'},  {id:'Continue, Agents Unavailable',name:'Continue, Agents Unavailable'}, {id:'Transfer',name:'Transfer'}, {id:'Disconnect',name:'Disconnect'}]
            for(var act of actions){
                if(this.state.ActionAfterPlaying === act.name){
                    var initialValue = act
                }
            }
			if (this.state.editingMessage) {
				editMessage = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop">
							<div className="viewCloser" onClick={this.cancelEditMessage}>X</div>
							<div>You Are Editing Message {this.state.editPrompt}</div>
							<br/>
							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.description} onChange={this.editDescription} ></input>
								<span className="inputBar"></span><label className="textLabel">Prompt Description</label>
							</div>
                            <div>Action After Playing</div>
							<ReactSuperSelect style={{flex: '1 0 150px', margin: '0px'}}  onChange={this.editAction} initialValue={initialValue} placeholder="Action After Playing" dataSource={actions} />
							<br/>

							<div style={{display: 'inline-block'}}>
								<div>Start</div>
								<Flatpickr style={{border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px'}} options={{dateFormat:"Y-m-d h:i K"}} data-enable-time value={this.state.start} onChange={date => { date[0] ? this.setState({start: date[0]}) : this.setState({start: undefined}) }} />
							</div>
							<div style={{display: 'inline-block'}}>
								<div>End</div>
								<Flatpickr style={{border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px'}} options={{dateFormat:"Y-m-d h:i K"}} data-enable-time value={this.state.end} onChange={date => { date[0] ? this.setState({end: date[0]}) :this.setState({end: undefined}) }} />
							</div>

							<div style={{ paddingTop: '25px',display: 'flex', justifyContent: 'space-around'}}>
								<div >
									<div>Active</div>
									<div className="activeBox" onClick={this.toggle('active')}>
										<div className={this.state.active ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>
							<div className="error" style={{padding: '15px'}}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button"  onClick={this.confirmEditMessage}>Confirm Message</div>}
						</div>
					</div>
				)
			}


			return (
				<div width="100%">
					<div className="dataHeaders">
						<span style={{flex: '0 0 75px', cursor: 'pointer'}} onClick={this.sort} data-sortBy="enabled">Active?</span>
						<span style={{flex: '1 0 20%', cursor: 'pointer'}} onClick={this.sort} data-sortBy="name">Message</span>
						<span style={{flex: '0 0 200px', cursor: 'pointer'}} onClick={this.sort} data-sortBy="modified">Action</span>
						<span style={{flex: '1 0 30%', cursor: 'pointer'}} onClick={this.sort} data-sortBy="modified">Date/Time Range</span>
					</div>
					<div style={{overflow: 'auto', height: 'calc(100% - 85px)'}}>
						{smList}
					</div>

					{editMessage}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

export default SpecialMessages



// WEBPACK FOOTER //
// ./src/Views/SpecialMessages.js